export default __webpack_public_path__ + "static/media/mywindow_attendance.a9830aa6.jpg";